'use client';

import { useTranslations } from 'next-intl';
import {
  Filter,
  FilteredCounter,
  ListPageFilterPanel,
} from '@terra/ui-design-system';
import type { AssetFilterRowConfig } from './useExternalNetworkAssetListFilters';

type ExternalNetworkAssetsFilterPanelProps = {
  filterRow: AssetFilterRowConfig;
  hasActiveFilters: boolean;
  filteredCount: number;
  onClear: () => void;
};

export function ExternalNetworkAssetsFilterPanel({
  filterRow,
  hasActiveFilters,
  filteredCount,
  onClear,
}: ExternalNetworkAssetsFilterPanelProps) {
  const t = useTranslations('proxy.filteredCounter.entities');
  const { filters, filterValue, onFilterChange } = filterRow;

  return (
    <ListPageFilterPanel
      isClearDisabled={!hasActiveFilters}
      onClear={onClear}
      trailing={
        hasActiveFilters ? (
          <FilteredCounter
            filteredCount={filteredCount}
            entityLabel={t('assets')}
          />
        ) : null
      }
    >
      {filters.map((filter) => (
        <Filter
          key={filter.id}
          {...filter}
          density="compact"
          value={filterValue.find((entry) => entry.id === filter.id)?.value}
          onChange={(nextSelectedOptions) =>
            onFilterChange([
              ...filterValue.filter((entry) => entry.id !== filter.id),
              ...(nextSelectedOptions.length > 0
                ? [{ id: filter.id, value: nextSelectedOptions }]
                : []),
            ])
          }
        />
      ))}
    </ListPageFilterPanel>
  );
}
